import { createSelector } from "reselect";
import { v4 as uuidv4 } from "uuid";

import type { TeamsGroup } from "rivals/components/pages/Teams/TeamsGroupsList/types";
import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { HighschoolGroup } from "rivals/shared/interfaces/HighschoolGroup";
import { State } from "./reducer";

export const getHighschoolState = (state: AppState): State =>
  state[StateKeys.HIGHSCHOOL];

export const selectHighschoolGroups = createSelector(
  getHighschoolState,
  state => state.highschoolGroups
);

export const selectHighschoolLetterGroups = createSelector(
  getHighschoolState,
  state => state.highschoolLetterGroups
);

export const selectHighschoolGroup = createSelector(
  getHighschoolState,
  state => state.highschoolGroup
);

export const selectSubmitting = createSelector(
  getHighschoolState,
  state => state.submitting
);

const formatHighschoolGroupsAsTeamGroups = (
  highschoolGroups?: HighschoolGroup[]
): TeamsGroup[] | undefined =>
  highschoolGroups?.map(group => ({
    id: `group-${uuidv4()}`,
    teams: group.items?.map(team => ({
      color: team.primaryColor || team.secondaryColor,
      id: `team-${uuidv4()}`,
      name: team.friendlyName || team.name,
      seoUrls: {
        forumsUrl: team.forumsUrl,
        siteHomeUrl: team.baseUrl
      }
    })),
    title: group.title
  }));

export const selectHighschoolGroupsAsTeamGroups = createSelector(
  selectHighschoolGroups,
  groups => formatHighschoolGroupsAsTeamGroups(groups)
);

export const selectHighschoolLetterGroupsAsTeamGroups = createSelector(
  selectHighschoolLetterGroups,
  groups => formatHighschoolGroupsAsTeamGroups(groups)
);

export const selectHighschoolGroupAsTeamGroups = createSelector(
  selectHighschoolGroup,
  group => (group ? formatHighschoolGroupsAsTeamGroups([group]) : [])
);
